import {
  RECORD_ID,
  OUTPUT_APPLICATION_ID,
} from "../../../../../../../../utils/constants";
import type {
  ActionOutputData,
  InputData,
  RecordJobData,
} from "@smartsuite/automation-engine-api";
import {
  getInputLabel,
  addEmptyValueIfNeeded,
} from "../../../../../../ActivityGrid/ActivityGrid.helpers";

import { ActivityDetailsItem } from "../../../../ActivityDetailsItem/ActivityDetailsItem";
import type { ActionCandidate } from "../../../../../../../../types/candidate";
import type { ReactElement } from "react";
import type { JobDetails } from "../../../../ActivityDetails.types";
import { StyledInputList } from "./styles";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../../../../../stores/hooks";

interface InputListProps {
  recordJobData?: RecordJobData;
  jobDetails: JobDetails;
  action: ActionOutputData;
  inputs?: InputData[];
  getInputValue: (
    input: InputData,
    jobDetails: JobDetails,
    recordJobData?: RecordJobData,
  ) => string;
  selectedActionFallback?: ActionCandidate;
}

export const InputList = observer<InputListProps>(
  ({
    recordJobData,
    jobDetails,
    getInputValue,
    action,
    inputs,
    selectedActionFallback,
  }): ReactElement | null => {
    const { automations } = useRootStore();
    const filteredInputs = inputs?.filter(
      (input) => ![RECORD_ID, OUTPUT_APPLICATION_ID].includes(input.inputId),
    );

    if (filteredInputs?.length === 0) {
      return null;
    }

    return (
      <StyledInputList>
        {filteredInputs?.map((input, index) => (
          <li key={input.inputId}>
            <ActivityDetailsItem
              label={getInputLabel(
                input,
                jobDetails,
                action,
                automations.candidate.allActions,
                selectedActionFallback,
                index,
              )}
            >
              {addEmptyValueIfNeeded(
                getInputValue(input, jobDetails, recordJobData),
              )}
            </ActivityDetailsItem>
          </li>
        ))}
      </StyledInputList>
    );
  },
);
